<template>
  <div>
    <approve
      v-if="needApproval === true"
      :vaultInfo="vaultInfo"
      :selectedAsset="selectedAsset"
      :txPayload="txPayload"
      @setInfiniteCheck="v => (infiniteCheck = v)"
      @next="needApproval = false"
    />
    <confirm
      v-if="needApproval === false"
      :vaultInfo="vaultInfo"
      :selectedAsset="selectedAsset"
      :txPayload="txPayload"
      :infiniteCheck="infiniteCheck"
      :needApproveAccess="needApproveAccess"
    />
  </div>
</template>

<script>
import Approve from "./Approve.vue";
import Confirm from "./Confirm.vue";

export default {
  components: {
    Approve,
    Confirm,
  },
  props: ["vaultInfo", "selectedAsset", "needApproveAccess", "txPayload"],
  data: () => ({
    needApproval: null,
    infiniteCheck: true,
  }),
  mounted() {
    this.needApproval = this.needApproveAccess || false;
  },
};
</script>
